import PageHero from "@/components/PageHero";
import RoomCard from "@/components/RoomCard";
import CTABanner from "@/components/CTABanner";
import { Reveal } from "@/components/Reveal";
import { renderAccent } from "@/components/RichText";
import { useSite } from "@/context/ContentContext";
import { Check } from "lucide-react";

export default function RoomsPage() {
  const D = useSite();
  const p = D.pages.odalar;
  const inc = D.included;
  return (
    <>
      <PageHero overline={p.overline} titleLines={p.titleLines} description={p.description} />
      <section className="mx-auto max-w-7xl px-6 pb-24 md:px-12">
        <div className="grid gap-x-8 gap-y-16 md:grid-cols-2">
          {D.rooms.map((room, i) => (
            <RoomCard key={room.slug || room.name} room={room} index={i} />
          ))}
        </div>

        <Reveal className="mt-24">
          <div className="rounded-[2rem] border border-gold/20 bg-gradient-to-br from-cream-100 to-rose-50 p-10 md:p-14">
            <div className="grid items-center gap-10 md:grid-cols-2">
              <div>
                <p className="font-accent text-xs uppercase tracking-[0.3em] text-gold-dark">{inc.overline}</p>
                <h2 className="mt-4 font-serif text-3xl tracking-tight text-charcoal-900 md:text-4xl">
                  {renderAccent(inc.title)}
                </h2>
                <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{inc.description}</p>
              </div>
              <ul className="grid gap-4 sm:grid-cols-2">
                {inc.items.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-charcoal-800/85">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold-dark">
                      <Check className="h-3 w-3" strokeWidth={2.5} />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
      </section>
      <CTABanner />
    </>
  );
}
